// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-card {
  background: #ffffff;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  max-width: 100%;
}

.task-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.task-card.dark-theme {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}

.task-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f7fafc;
}

.task-card.dark-theme .task-card-header {
  border-bottom-color: #4a5568;
}

.task-card-header h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #2d3748;
}

.task-card.dark-theme .task-card-header h3 {
  color: #e2e8f0;
}

.team-name {
  color: #3bbddb;
  font-size: 0.9rem;
  font-weight: 500;
}
.task-card.dark-theme .team-name {
  color: #ffffff;
}

.task-card-content {
  min-height: 60px;
  display: flex;
  align-items: center;
}

.task-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #4a5568;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.task-card.dark-theme .task-text {
  color: #cbd5e0;
}

.task-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #718096;
  font-style: italic;
}

.task-card.dark-theme .task-loading {
  color: #a0aec0;
}

.task-error {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e53e3e;
  font-weight: 500;
}

.task-card.dark-theme .task-error {
  color: #fc8181;
}

.task-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #a0aec0;
  font-style: italic;
}

.task-card.dark-theme .task-empty {
  color: #718096;
}

.task-empty span {
  font-size: 1rem;
  margin-bottom: 5px;
}

.task-empty small {
  font-size: 0.85rem;
  opacity: 0.8;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .task-card {
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .task-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .task-card-header h3 {
    font-size: 1.1rem;
  }
  
  .team-name {
    font-size: 0.8rem;
  }
  
  .task-text {
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/TaskCard/TaskCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".task-card {\r\n  background: #ffffff;\r\n  border: 2px solid #e1e5e9;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.3s ease;\r\n  max-width: 100%;\r\n}\r\n\r\n.task-card:hover {\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.task-card.dark-theme {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.task-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 15px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 2px solid #f7fafc;\r\n}\r\n\r\n.task-card.dark-theme .task-card-header {\r\n  border-bottom-color: #4a5568;\r\n}\r\n\r\n.task-card-header h3 {\r\n  margin: 0;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n}\r\n\r\n.task-card.dark-theme .task-card-header h3 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.team-name {\r\n  color: #3bbddb;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n.task-card.dark-theme .team-name {\r\n  color: #ffffff;\r\n}\r\n\r\n.task-card-content {\r\n  min-height: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.task-text {\r\n  font-size: 1rem;\r\n  line-height: 1.6;\r\n  color: #4a5568;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.task-card.dark-theme .task-text {\r\n  color: #cbd5e0;\r\n}\r\n\r\n.task-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #718096;\r\n  font-style: italic;\r\n}\r\n\r\n.task-card.dark-theme .task-loading {\r\n  color: #a0aec0;\r\n}\r\n\r\n.task-error {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #e53e3e;\r\n  font-weight: 500;\r\n}\r\n\r\n.task-card.dark-theme .task-error {\r\n  color: #fc8181;\r\n}\r\n\r\n.task-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  color: #a0aec0;\r\n  font-style: italic;\r\n}\r\n\r\n.task-card.dark-theme .task-empty {\r\n  color: #718096;\r\n}\r\n\r\n.task-empty span {\r\n  font-size: 1rem;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.task-empty small {\r\n  font-size: 0.85rem;\r\n  opacity: 0.8;\r\n}\r\n\r\n/* Адаптивность для мобильных устройств */\r\n@media (max-width: 768px) {\r\n  .task-card {\r\n    padding: 15px;\r\n    margin-bottom: 15px;\r\n  }\r\n  \r\n  .task-card-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .task-card-header h3 {\r\n    font-size: 1.1rem;\r\n  }\r\n  \r\n  .team-name {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .task-text {\r\n    font-size: 0.95rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
